#import '../fragment/customer.graphql'

mutation createCustomer($customer: CustomerInput) {
  createCustomer(customer: $customer) {
    ...customerFragment
  }
}
